module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestfold_telemark_pos.df599834.svg";